
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M6 8.5 7 13l1.5-3 1.5 3 1-4.5m-1.5-7H4.333c-.46 0-.833.392-.833.875v12.25c0 .483.373.875.833.875h8.334c.46 0 .833-.392.833-.875V5.5m-4-4v4h4m-4-4 4 4"}})])
          )
        }
      }
    